import React from 'react';

/** Curved arrow scribble — student's graphite pencil doodle */
export const ScribbleArrow: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 80 60" fill="none" {...props}>
    <path
      d="M8,12 C18,8 32,6 48,14 C64,22 70,38 66,50"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M60,44 L66,50 L72,42"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Star scribble — teacher's gold star sticker */
export const ScribbleStar: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <path
      d="M20,4 L23,15 L34,15 L25,22 L28,33 L20,26 L12,33 L15,22 L6,15 L17,15 Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

/** Exclamation mark scribble — teacher's red pen annotation */
export const ScribbleExclamation: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 40" fill="none" {...props}>
    <path
      d="M12,4 C12.5,6 13,14 12.5,22 C12,24 11.5,22 12,4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="32" r="2.5" fill="currentColor" />
  </svg>
);

/** Checkmark scribble — teacher's green approval mark */
export const ScribbleCheck: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 36 36" fill="none" {...props}>
    <path
      d="M6,20 C8,22 12,26 14,28 C16,24 22,14 30,8"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Calculator scribble — for CTA banner */
export const ScribbleCalculator: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 40 48" fill="none" {...props}>
    <rect x="5" y="4" width="30" height="40" rx="3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <rect x="9" y="8" width="22" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    <circle cx="15" cy="26" r="2.5" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="25" cy="26" r="2.5" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="15" cy="36" r="2.5" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="25" cy="36" r="2.5" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

/** Small circle scribble — hand-drawn imperfect circle */
export const ScribbleCircle: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <path
      d="M20,5 C28,4 35,10 36,18 C37,26 31,34 22,35 C13,36 6,30 5,22 C4,14 10,6 20,5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
